import React from 'react';
import { ProductType, VehicleType } from '../components/common/CommonTypes';
import useAlloyRepairRequest from '../components/hooks/useAlloyRepairRequest';
import { AlloyPageState } from '../components/sitePages/alloyRepairRequest/AlloyRepairRequestTypes';
import { AlloyRepairRequestContext } from './AlloyRepairRequestContext';

type AlloyRepairRequestProviderProps = {
    children: React.ReactNode;
    initialState: AlloyPageState;
    product: ProductType;
    vehicle: VehicleType;
};

const AlloyRepairRequestProvider = ({
    children,
    initialState,
    product,
    vehicle
}: AlloyRepairRequestProviderProps): JSX.Element => {
    const {
        progressBarItems,
        alloyRepairRequest,
        onSelectAlloyType,
        onChangeMileage,
        onWheelValueChange,
        onAlloyWheelRepairRequestChangeWheel,
        onWheelSelected,
        onChangeDamageType,
        onRepairAddressSelectionChanged,
        onUploadImageChange,
        onFinishAddingWheels,
        onTogglePermission,
        onFinishedAlloyRepairRequest,
        onContinueToRepairAddress,
        onContinueRepairRequest,
        onDeleteRepairRequest,
        onCancelClick,
        onCancelRepairRequest,
        onCancelUndo,
        onChangeStage,
        onUpdateWheelClick,
        onUpdateAddressClick
    } = useAlloyRepairRequest(initialState, product, vehicle);

    return (
        <AlloyRepairRequestContext.Provider
            value={{
                product,
                vehicle,
                progressBarItems,
                alloyRepairRequest,
                onSelectAlloyType,
                onChangeMileage,
                onWheelValueChange,
                onAlloyWheelRepairRequestChangeWheel,
                onWheelSelected,
                onChangeDamageType,
                onRepairAddressSelectionChanged,
                onUploadImageChange,
                onFinishAddingWheels,
                onTogglePermission,
                onFinishedAlloyRepairRequest,
                onContinueToRepairAddress,
                onContinueRepairRequest,
                onDeleteRepairRequest,
                onCancelClick,
                onCancelRepairRequest,
                onCancelUndo,
                onChangeStage,
                onUpdateWheelClick,
                onUpdateAddressClick
            }}>
            {children}
        </AlloyRepairRequestContext.Provider>
    );
};

export default AlloyRepairRequestProvider;
